import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Button, Tabs, Tab, TextField, Select, MenuItem, Tooltip, InputBase, IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "./TransactionTable.css";
import qs from "qs";
import CryptoJS from "crypto-js";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import { useRO } from "../Dashboards/ROContext";
import ROSelect from "../Dashboards/ROSelect";
import OutlinedSelect from "../OutlinedSelect"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Dialog,
  DialogContent,
  DialogActions
} from "@mui/material";
 import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';


const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
    const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
    const message = `${method}${urlPath}${timestamp}`;
    return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const fuelColumns = [
    { label: "User Name", field: "user_name" },  // Updated field to User Name
    { label: "Outlet Name", field: "ro_name" },
    { label: "Quantity(Litre/KG)", field: "quantity" },
    { label: "Reward Points", field: "earned_reward_point" },
    { label: "Date", field: "date" },
    { label: "Phone Number", field: "phone" },
    { label: "Fuel Type", field: "fueltype" },
    { label: "Vehicle Number", field: "vehiclenumber" },
    { label: "Bill Number/Image", field: "billnumber" },
    
];
 const REPORT_TYPES = [
  { label: "Fuel", value: "Fuel" },
  { label: "Redemption", value: "Redemption" },
  
];
const redemptionColumns = [
    { label: "User Name", field: "user_name" },  // Updated field to User Name
    { label: "Outlet Name", field: "ro_name" },
    { label: "Redeemed Reward Points", field: "redeemed_reward_point" },
    { label: "Date", field: "date" },
    { label: "Phone Number", field: "phone" },
    { label: "Gift Name", field: "gift_name" },
    { label: "Gift Category", field: "gift_category" },
];
const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    timeZone: "Asia/Kolkata"
  });
};
const TransactionTable = () => {
    const [activeTab, setActiveTab] = useState("Fuel");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [filter, setFilter] = useState("Select...");
    const [sortOrder, setSortOrder] = useState("desc");
    const [duplicateKeys, setDuplicateKeys] = useState(new Set());
    const [showSearch, setShowSearch] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [openBill, setOpenBill] = useState(false);
const [billImageUrl, setBillImageUrl] = useState("");

    const searchRef = useRef();
const { selectedRoId } = useRO();

    useEffect(() => {
        if (filter !== "Custom Range" && filter !== "Select...") {
            calculateDateRange();
        }
    }, [filter]);

    useEffect(() => {
        findDuplicateEntries();
    }, [data]);

    const calculateDateRange = () => {
        let today = new Date();
        let pastDate = new Date(today);
        switch (filter) {
            case "One Month": pastDate.setMonth(today.getMonth() - 1); break;
            case "Three Months": pastDate.setMonth(today.getMonth() - 3); break;
            case "Six Months": pastDate.setMonth(today.getMonth() - 6); break;
            case "One Year": pastDate.setFullYear(today.getFullYear() - 1); break;
            default: return;
        }
        setFromDate(pastDate.toISOString());
        setToDate(today.toISOString());
    };

    useEffect(() => {
        if (fromDate && toDate && fromDate <= toDate) {
            fetchTransactions();
        }
    }, [fromDate, toDate, activeTab,selectedRoId]);

    const fetchTransactions = async () => {
        setLoading(true);
        setError(null);
        setData([]);
        const selectedFromDate = fromDate;
        const selectedToDate = toDate;
        const token = localStorage.getItem("authToken");
        if (!token) {
            setError("User not authenticated");
            setLoading(false);
            return;
        }

        const method = "GET";
        const timestamp = Math.floor(Date.now() / 1000).toString();
        const apiUrl = activeTab === "Fuel"
            ? "/v2/user/transactions/fuel/range"
            : "/v2/user/transactions/redemption/range";
        const signature = generateSignature(method, apiUrl, timestamp);
        const queryParams = qs.stringify({ start_date: selectedFromDate,
            end_date: selectedToDate,ro_id:selectedRoId});

        try {
            const response = await axios.get(`${API_BASE_URL}${apiUrl}?${queryParams}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "X-Signature": signature,
                    "X-Timestamp": timestamp,
                },
            });

            const transactions = Array.isArray(response.data.transactions)
                ? response.data.transactions
                : Array.isArray(response.data)
                ? response.data
                : [];

            // Combine first name and last name into User Name
            const updatedData = transactions.map(transaction => ({
                ...transaction,
                user_name: (transaction.user_firstname || transaction.user_lastname)
                    ? `${transaction.user_firstname || ""} ${transaction.user_lastname || ""}`.trim()
                    : transaction.userid,
            }));   
           

            setData(updatedData);
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch data");
        }

        setLoading(false);
    };

    const findDuplicateEntries = () => {
        const seen = new Map();
        const duplicates = new Set();

        data.forEach((entry) => {
            const key = `${entry.userid}-${entry.phone}`;
            const dateI = new Date(entry.date);

            if (!seen.has(key)) {
                seen.set(key, [{ date: dateI, fullKey: `${entry.userid}-${entry.phone}-${entry.date}` }]);
            } else {
                const prevEntries = seen.get(key);
                for (let { date: prevDate, fullKey: prevFullKey } of prevEntries) {
                    const diffInHours = Math.abs(dateI - prevDate) / (1000 * 60 * 60);
                    if (diffInHours < 24) {
                        duplicates.add(`${entry.userid}-${entry.phone}-${entry.date}`);
                        duplicates.add(prevFullKey);
                        break;
                    }
                }
                prevEntries.push({ date: dateI, fullKey: `${entry.userid}-${entry.phone}-${entry.date}` });
            }
        });

        setDuplicateKeys(duplicates);
    };
    
const handleOpenBill = (url) => {
  if (!url) return;
  setBillImageUrl(url);
  setOpenBill(true);
};
const fetchBillImage = async (transactionId) => {
  try {
    const token = localStorage.getItem("authToken");
    const timestamp = Math.floor(Date.now() / 1000).toString();
    const apiUrl = "/v1/user/transactions/fuel/image";
    const signature = generateSignature("GET", apiUrl, timestamp);
//transactionId=qs.stringify(transactionId);
    const response = await axios.get(
      `${API_BASE_URL}${apiUrl}?transaction_id=${transactionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Signature": signature,
          "X-Timestamp": timestamp,
        },
      }
    );

    // 🔥 IMPORTANT PART
    const imageUrl =
      response.data?.message ||
      response.data?.url ||
      response.data?.bill_image;
     

    if (!imageUrl) {
      alert("Bill image not available");
      return;
    }

    setBillImageUrl(imageUrl);
    setOpenBill(true);
  } catch (error) {
    alert("Bill image not available");
  }
};



const handleCloseBill = () => {
  setOpenBill(false);
  setBillImageUrl("");
};

const handlepdfexport = () => { 

      if (data.length === 0) {
        alert("No data to export!");
        return;
      }

       const columnsToExport =
    activeTab === "Fuel"
      ? fuelColumns
      : [...redemptionColumns, { label: "Gift Price", field: "gift_price" }];

  // ✅ Headers must be labels
  const headers = columnsToExport.map(col => col.label);

  // ✅ Body must match column order
  const body = data.map(row =>
    columnsToExport.map(col => {
      const value = row[col.field];

      if (!value) return "N/A";

      if (
        col.field.toLowerCase().includes("date") ||
        col.field.toLowerCase().includes("dob")
      ) {
        return formatDateTime(value);
      }

      return value;
    })
  );

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4"
  });

  const title =
    activeTab === "Fuel"
      ? "Fuel Transactions Report"
      : "Redemption Transactions Report";

  doc.setFontSize(14);
  doc.text(title, 40, 40);

  autoTable(doc, {
    startY: 60,
    head: [headers],
    body: body,
    styles: {
      fontSize: 9,
      cellPadding: 6
    },
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: 20,
      fontStyle: "bold"
    },
    margin: { left: 40, right: 40 },
    didDrawPage: (dataArg) => {
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(9);
      doc.text(
        `Page ${dataArg.pageNumber}`,
        doc.internal.pageSize.width - 60,
        pageHeight - 10
      );
    }
  });
      // Save file
      //const filename = ${activeTab}+"_trasactions.pdf";
      if(activeTab==="Fuel")
      {
         doc.save("Fuel_transactions.pdf");
      }
      else
      {
        doc.save("Redemptions_transactions.pdf");
      }
    
};


    const handleExport = () => {
        if (data.length === 0) {
            alert("No data to export!");
            return;
        }

        const columnsToExport = activeTab === "Fuel"
            ? fuelColumns
            : [...redemptionColumns, { label: "Gift Price", field: "gift_price" }];

        const exportData = data.map((row) => {
        const rowData = {};
        columnsToExport.forEach(col => {
            const value = row[col.field];
            if (col.field.toLowerCase().includes("date") || col.field.toLowerCase().includes("dob")) {
                rowData[col.label] = formatDateTime(value);
            } else {
                rowData[col.label] = value || "N/A";
            }
        });
            if (activeTab === "Fuel") {
                const isDuplicate = duplicateKeys.has(`${row.userid}-${row.phone}-${row.date}`);
                rowData["Is Duplicate?"] = isDuplicate ? "YES" : "NO";
              }
            return rowData;
        });
            

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
        XLSX.writeFile(workbook, `${activeTab}_transactions.xlsx`);
    };

    const toggleSortOrder = () => {
        setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    };

    const filteredData = data.filter(row =>
        Object.values(row).some(val =>
            val?.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const sortedData = [...filteredData].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

    const columnsToDisplay = activeTab === "Fuel" ? fuelColumns : redemptionColumns;

    return (
        <><div className="transaction-container">
                        


                <div className="controls-container" style={{ display: "flex", gap: "10px" }}>
                    
                    <div className="ro-dropdown" style={{ color:"black" }}>
                            <ROSelect className="roSelectInline" theme="light" labelClassName="roLable" />
                          </div>
                      
                      <OutlinedSelect
  label="Report"
  value={activeTab}
  onChange={(e) => {
    setActiveTab(e.target.value);
    setData([]);
    setError(null);
  }}
  minWidth={160}
  options={[
    { label: "Fuel", value: "Fuel" },
    { label: "Redemption", value: "Redemption" },
  ]}
/>

                    <OutlinedSelect
  label="Range"
  value={filter}
  onChange={(e) => {
    const val = e.target.value;
    setFilter(val);
    if (val === "Select...") {
      setData([]);
      setError(null);
    }
  }}
  sx={{
  minWidth: 180,
  flex: "1 1 180px",   // 🔥 allows shrink & wrap
  maxWidth: 280
}}

  options={[
    { label: "Select...", value: "Select..." },
    { label: "One Month", value: "One Month" },
    { label: "Three Months", value: "Three Months" },
    { label: "Six Months", value: "Six Months" },
    { label: "One Year", value: "One Year" },
    { label: "Custom Range", value: "Custom Range" },
  ]}
/>


                    {filter === "Custom Range" && (
                        <>
                            <TextField type="date" label="From" value={fromDate} onChange={(e) => setFromDate(e.target.value)} InputLabelProps={{ shrink: true }} />
                            <TextField type="date" label="To" value={toDate} onChange={(e) => setToDate(e.target.value)} InputLabelProps={{ shrink: true }} />
                        </>
                    )}

                    <Tooltip title="Refresh">
                        <Button onClick={fetchTransactions} className="small-button">
                            <RefreshIcon />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Export to Excel">
                        <Button onClick={handleExport} className="small-button">
                            <FileDownloadOutlinedIcon />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Download to PDF">
            <Button onClick={handlepdfexport} className="small-button"><PictureAsPdfIcon/></Button>
          </Tooltip>
                    <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }} ref={searchRef}>
                        {showSearch && (
                            <div style={{ position: "relative", display: "flex", alignItems: "center", background: "#f0f0f0", paddingLeft: 10, marginTop: 5, borderRadius: 5 }}>
                                <InputBase
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{ flex: 1 }} />
                                {searchText && (
                                    <IconButton className="close-button" size="small" onClick={() => setSearchText("")}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                )}

                            </div>
                        )}

                    </div>
                </div>

                {activeTab === "Fuel" && data.length > 0 && (
                    <p style={{ fontWeight: "bold", color: "#1976d2", marginTop: "10px", marginLeft: "10px" }}>
                        Note : Highlighted rows are repeat customers within 24 hours.
                    </p>
                )}

                {loading ? (
                    <p>Loading transactions...</p>
                ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                ) : (
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow style={{ background: "lightgrey" }}>
                                    {columnsToDisplay.map(col => (
                                        <TableCell
                                            key={col.field}
                                            style={{
                                                fontWeight: "bold",
                                                cursor: col.field === "date" ? "pointer" : "default",
                                                border: "2px solid #a7a4a4"
                                            }}
                                            onClick={col.field === "date" ? toggleSortOrder : undefined}
                                        >
                                            {col.label}
                                            {col.field === "date" && (sortOrder === "asc" ? " 🔼" : " 🔽")}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedData.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        //duplicateKeys.has(rowKey) ? highlight : normal;
                                        style={activeTab === "Fuel" && duplicateKeys.has(`${row.userid}-${row.phone}-${row.date}`)
                                            ? { backgroundColor: "#FFF9C4" }
                                            : {}}
                                    >
                                        {columnsToDisplay.map((col, colIndex) => (
                                            <TableCell key={`${index}-${colIndex}`}>
  {col.field === "billnumber" ? (
    row.billnumber ? (
     <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr auto",
    alignItems: "center",
    width: "100%",
  }}
>
  {/* Bill Number – LEFT */}
  <span
    style={{
      fontSize: "13px",
      fontWeight: 500,
      whiteSpace: "nowrap",
      justifySelf: "start",
    }}
  >
    {row.billnumber}
  </span>

  {/* Eye Icon – RIGHT */}
  {row.has_image && (
    <Tooltip title="View Bill">
      <IconButton
        size="small"
        onClick={() => fetchBillImage(row.id)}
        sx={{ padding: "4px", justifySelf: "end" }}
      >
        <VisibilityOutlinedIcon fontSize="small" color="primary" />
      </IconButton>
    </Tooltip>
  )}
</div>



    ) : (
      "N/A"
    )
  ) : (
    (col.field.toLowerCase().includes("date") ||
    col.field.toLowerCase().includes("dob"))
      ? formatDateTime(row[col.field])
      : (row[col.field] || "N/A")
  )}
</TableCell>



                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                <Dialog open={openBill} onClose={handleCloseBill} maxWidth="sm" fullWidth>
  <DialogContent style={{ textAlign: "center" }}>
    {billImageUrl ? (
      <img
        src={billImageUrl}
        alt="Bill"
        style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
      />
    ) : (
      <p>No bill image available</p>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseBill}>Close</Button>
    {billImageUrl && (
 <Button
  variant="contained"
  component="a"
  href={billImageUrl}
  target="_blank"
  rel="noopener noreferrer"
>
  Download
</Button>

    )}
  </DialogActions>
</Dialog>

            </div></>
    );
};

export default TransactionTable;
